import { Variant } from "../../types/types";

export const getStoreStockSkuId = (variant: Variant) => {
  if (
    variant.__typename === "StaticBundleVariant" ||
    variant.__typename === "RetiredStaticBundleVariant"
  ) {
    // @ts-ignore
    return variant.components[0].variant.aliases.skuId;
  }

  return variant.aliases.skuId;
};
